import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { func, string } from "prop-types";

import GlobalState from "../../../../../../../shared/utilities/globalState";
import { registerIndustryConfirmationGA } from "../../../../analytics/ga";
import {
  ConfirmationWrapper,
  MobileLineBrake,
  ModalCompleteText,
  ModalHeading,
  ModalText,
  TextBold,
  XButtonWrapper
} from "../../styled";

class RegisterIndustryConfirmation extends React.Component {
  static propTypes = {
    email: string.isRequired,
    handleCloseModal: func.isRequired,
    scenario: string.isRequired
  };

  // GA starts
  componentDidMount() {
    if (GlobalState.get("analyticsData")) {
      this.source = GlobalState.get("analyticsData").source || null;
    }

    registerIndustryConfirmationGA.checkEmailModalOpens(
      this.source,
      "industry"
    );
  }
  // GA ends

  render() {
    return (
      <ConfirmationWrapper minHeight>
        <ModalHeading scenario={this.props.scenario}>
          <ModalCompleteText
            isComplete
            scenario={this.props.scenario}
            type="primarySm"
          >
            Complete your registration
          </ModalCompleteText>
          <XButtonWrapper>
            <XButton onClick={this.props.handleCloseModal} />
          </XButtonWrapper>
        </ModalHeading>
        <ModalText>
          <Text type="sm">
            <span>
              For access to your account, use the link in the email we sent to
            </span>
            <span>
              &nbsp;
              <wbr />
            </span>
            <MobileLineBrake>
              <TextBold as="span" type="sm">
                {this.props.email}
              </TextBold>
            </MobileLineBrake>
          </Text>
        </ModalText>
      </ConfirmationWrapper>
    );
  }
}

export default RegisterIndustryConfirmation;
